"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.union = exports.sort = exports.some = exports.oneOf = exports.omitNils = exports.mergeAll = exports.merge = exports.map = exports.isEmpty = exports.intersect = exports.flatMap = exports.flatten = exports.every = exports.dedupe = exports.areSame = exports.areNil = exports.anyNil = exports.areNotNil = void 0;

var Classify = _interopRequireWildcard(require("../Classify"));

var Logic = _interopRequireWildcard(require("../Logic"));

var Objects = _interopRequireWildcard(require("../Objects"));

var Nil = _interopRequireWildcard(require("../Nil"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var areNotNil = function areNotNil(xs) {
  return xs.every(Nil.isNotNil);
};

exports.areNotNil = areNotNil;

var anyNil = function anyNil(xs) {
  return xs.some(Nil.isNil);
};

exports.anyNil = anyNil;

var areNil = function areNil(xs) {
  return xs.every(Nil.isNil);
};

exports.areNil = areNil;

var areSame = function areSame(xs) {
  return new Set(xs).size === 1;
};

exports.areSame = areSame;

var dedupe = function dedupe(xs) {
  return Array.from(new Set(xs));
};

exports.dedupe = dedupe;

var every = function every(predicate) {
  return function (xs) {
    return xs.every(predicate);
  };
};

exports.every = every;

var flatten = function flatten(xxs) {
  return xxs.reduce(function (acc, list) {
    return acc.concat(list);
  }, []);
};

exports.flatten = flatten;

var flatMap = function flatMap(mapper) {
  return function (xxs) {
    return xxs.reduce(function (acc, xs) {
      return acc.concat(xs);
    }, []).map(mapper);
  };
};

exports.flatMap = flatMap;

var intersect = function intersect(xs) {
  return function (ys) {
    return xs.filter(function (val) {
      return ys.includes(val);
    });
  };
};

exports.intersect = intersect;

var isEmpty = function isEmpty(xs) {
  return xs.length === 0;
};

exports.isEmpty = isEmpty;

var map = function map(mapper) {
  return function (xs) {
    return xs.map(function (x, i) {
      return mapper(x)(i);
    });
  };
};

exports.map = map;

var merge = function merge(xs) {
  return function (ys) {
    return xs.concat(ys);
  };
};

exports.merge = merge;

var mergeAll = function mergeAll(xxs) {
  return xxs.reduce(function (acc, xs) {
    return merge(acc)(xs);
  }, []);
};

exports.mergeAll = mergeAll;

var omitNils = function omitNils(arr) {
  return arr.reduce(function (acc, value) {
    Logic.caseOf({
      Array: function (_Array) {
        function Array(_x) {
          return _Array.apply(this, arguments);
        }

        Array.toString = function () {
          return _Array.toString();
        };

        return Array;
      }(function (arr_) {
        omitNils(arr_);
        return acc;
      }),
      Null: function Null() {
        return acc;
      },
      Object: function (_Object) {
        function Object(_x2) {
          return _Object.apply(this, arguments);
        }

        Object.toString = function () {
          return _Object.toString();
        };

        return Object;
      }(function (obj) {
        acc.push(Objects.omitNils(obj));
        return acc;
      }),
      Undefined: function Undefined() {
        return acc;
      },
      defaultCase: function defaultCase() {
        acc.push(value);
        return acc;
      }
    })(Classify.typeOf)(value);
    return acc;
  }, []);
};

exports.omitNils = omitNils;

var oneOf = function oneOf(defaultValue) {
  return function (xs) {
    return xs.reduce(function (x, y) {
      return x === defaultValue ? Nil.isNotNil(y) ? y : x : x;
    }, defaultValue);
  };
};

exports.oneOf = oneOf;

var some = function some(predicate) {
  return function (xs) {
    return xs.some(predicate);
  };
};

exports.some = some;

var sort = function sort(sorter) {
  return function (xs) {
    return xs.sort(function (x, y) {
      return sorter(x)(y);
    });
  };
};

exports.sort = sort;

var union = function union(xxs) {
  return Array.from(new Set(xxs.reduce(function (acc, xs) {
    return acc.concat(xs);
  }, [])));
};

exports.union = union;
//# sourceMappingURL=index.js.map